//pages

import {
  Dashboard,
  Seemore,
  PouDetails,
  Pou,
  PouEdit,
  PouAdd,
  Setting,
  SettingChangePassword,
  Batch,
  IssuedBatch,
  RetireBatch,
  RequestBatch,
  Requests,
  IssuedbatchSecond,
  ReceiveInventory,
  NodeView,
} from "./pages";

import DetailsPage from "../../components/DetailsPage";
//routes

import { districtRoutes, commonRoutes } from "../../Services/Routes/APP";

//admin routes export

export const adminroutes = [
  {
    id: `admin-122`,
    exact: false,
    path: districtRoutes?.root,
    component: Dashboard,
  },
  {
    id: `admin-123`,
    exact: false,
    path: districtRoutes?.dashboard,
    component: Dashboard,
  },
  {
    id: `admin-123`,
    exact: false,
    path: districtRoutes?.dashbordSeeMore,
    component: Seemore,
  },
  {
    id: `admin-124`,
    exact: false,
    path: districtRoutes?.poudetails,
    component: PouDetails,
  },
  {
    id: `admin-125`,
    exact: false,
    path: districtRoutes?.pou,
    component: Pou,
  },
  {
    id: `admin-126`,
    exact: false,
    path: districtRoutes?.editPou,
    component: PouEdit,
  },
  {
    id: `admin-127`,
    exact: false,
    path: districtRoutes?.addPou,
    component: PouAdd,
  },
  {
    id: `admin-128`,
    exact: false,
    path: districtRoutes?.setting,
    component: Setting,
  },
  {
    id: `admin-129`,
    exact: false,
    path: districtRoutes?.changePassword,
    component: SettingChangePassword,
  },
  {
    id: `admin-130`,
    exact: false,
    path: districtRoutes?.batch,
    component: Batch,
  },
  {
    id: `admin-131`,
    exact: false,
    path: districtRoutes?.issuedBatch,
    component: IssuedBatch,
  },
  {
    id: `admin-132`,
    exact: false,
    path: districtRoutes?.retireBatch,
    component: RetireBatch,
  },
  {
    id: `province-135`,
    exact: false,
    path: districtRoutes?.requests,
    component: Requests,
  },
  {
    id: `admin-133`,
    exact: false,
    path: districtRoutes?.request_inventory,
    component: RequestBatch,
  },
  {
    id: `province-136`,
    exact: false,
    path: districtRoutes?.issuedBatchManually,
    component: IssuedbatchSecond,
  },
  {
    id: `province-136`,
    exact: false,
    path: districtRoutes?.receiveInventory,
    component: ReceiveInventory,
  },
  {
    id: `district-137`,
    exact: false,
    path: commonRoutes?.batch?.details,
    component: DetailsPage,
  },
  {
    id: `district-138`,
    exact: false,
    path: commonRoutes?.request + commonRoutes?.details,
    component: DetailsPage,
  },
  {
    id: `province-139`,
    exact: false,
    path: commonRoutes?.nodeView,
    component: NodeView,
  },
  {
    id: `district-140`,
    exact: false,
    path: commonRoutes?.node?.details,
    component: DetailsPage,
  },
  {
    id: `district-141`,
    exact: false,
    path: commonRoutes?.node?.addPou,
    component: PouAdd,
  },
];
